import React from "react";
import LazyLoad from "react-lazyload";
import { partnerImg } from "../../assets/Data/partner";
import { AdvisorData, TeamData } from "../../assets/Data/TeamData";
import ImgList from "../ImgList";
import Member, { Advisor } from "./Member";
import "./team.scss";

const Team = () => {
    return (
        <section className="container bgWhite team ">
            <div className="grid wide">
                <div className="team__content">
                    <h3 className="textBox__title">Our Team</h3>
                    <div className="team__member">
                        {TeamData.map((item) => (
                            <LazyLoad key={item.id} height={50}>
                                <Member item={item} />
                            </LazyLoad>
                        ))}
                    </div>

                    <h3 className="textBox__title">Our Advisors</h3>
                    <div className="team__advisors">
                        {AdvisorData.map((item, index) => (
                            <LazyLoad key={index} height={50}>
                                <Advisor item={item} />
                            </LazyLoad>
                        ))}
                    </div>
                </div>

                <div className="partners">
                    <ImgList
                        title="Our Investors and Partners"
                        listImg={partnerImg}
                    />
                </div>
            </div>
        </section>
    );
};

export default Team;
